import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class ErrorBoundary extends Vue {
  @Prop(Boolean)
  stopPropagation!: boolean;

  @Prop({
    default: () => {
      return "text";
    }
  })
  type!: string;

  @Prop({
    default: () => {
      return "Failed to load data";
    }
  })
  errorMessage!: string;

  error = false;
  errorCaptured(error: string) {
    // eslint-disable-next-line no-console
    console.error(error);

    this.error = true;
    return !this.stopPropagation;
  }
}
